<template lang="html">
  <div class="col-lg-9 col-page-content page-style-1">

    <div class="row box-panel-top">
      <div class="col-12 box-acc-title-s1">
        <h4>Candidatos</h4>
        <hr />
      </div>
      

      <div class="col-lg-3 pl-lg-0 col-r">
        <!-- <h6 class="box-title">NOTIFICACIONES ACTIVADAS</h6> -->
      </div>
    </div>

    <div class="row box-candidates" v-if="$root.user.order_plan != null">
      <!-- Candidatos recientemente -->
      <div class="col-12 col-candidates-list">
        <div  class="row">
             <b-form-group class="col-md-4 custom-f-group-1" label="Sector" label-for="i-7">
                <b-form-group
                label-for="i-6">
                <v-select v-model="filter.category_id" :options="areasOpcs" label="nombre" index="id"/>
              </b-form-group>
            </b-form-group>
            <b-form-group class="col-md-4 custom-f-group-1" label="Estado" label-for="i-7">
                <b-form-group
                label-for="i-6">
                <v-select v-model="filter.state_id" :options="statesOpcs" label="name" index="id"/>
              </b-form-group>
            </b-form-group>
            <b-form-group class="col-md-4 custom-f-group-1" label="Ciudad" label-for="i-7">
                <b-form-group
                label-for="i-6">
                <v-select v-model="filter.town_id" :options="townsOpcs" label="name" index="id"/>
              </b-form-group>
            </b-form-group>
        </div>
        <div  class="row">
     
             <b-form-group class="col-md-6 custom-f-group-1" label="Buscar" label-for="i-6">
              <b-form-input
                id="i-6"
                v-model="filter.keywords"
                type="text"
                
                
              ></b-form-input>
            </b-form-group>

           
        </div>
        <div class="row">

          <div class="col-12 mb-2 col-title-filter">
            <div class="row align-items-center">
              <div class="col-12 col-sm box-acc-title-s2 col-subinfo">
               
              </div>

              <!-- <div class="col-12 col-sm ml-auto col-filters">
                <span>Mostrar: </span>
                <b-form-select v-model="formFilter">
                  <b-form-select-option :value="null">Todos los candidatos</b-form-select-option>
                  <b-form-select-option value="a">Candidatos guardados</b-form-select-option>
                  <b-form-select-option value="b">Candidatos descartados</b-form-select-option>
                </b-form-select>
              </div> -->
            </div>
          </div>

          <div class="col-12 col-candidate-s2" v-for="(postulate, cand1Inx) in postulates" :key="'cand1Inx-'+cand1Inx">
            <div class="box">
              <div class="col-vac-info">
                <div>
                  
                  <span>Fecha de registro: {{postulate.creado}}</span>
                  <span>Sueldo deseado: {{postulate.sueldodeseado}} {{postulate.sueldodeseado_periodo}}</span>
                  <!-- <span>Sueldo deseado: $18,500 mes</span> -->
                </div>
              </div>

              <div class="col col-photo">
                <div class="img" v-bind:style="{ backgroundImage: 'url('+postulate.imageUrl+')' }"></div>
              </div>

              <div class="col col-info">
                <h4 class="name"><router-link target="_blank" :to="'/perfil-candidato/'+$root._converToURL(postulate.name, postulate.usuarios_id)">{{postulate.name}}</router-link></h4>
                <h5>
                  <span class="career">{{postulate.area}}</span><br />
                  <i class="loc-icon"></i><span class="location">{{postulate.state}}, {{postulate.town}}</span>
                </h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-2ndbuttons">
                <a :href="'mailto:'+postulate.email" class="btn-msg" >
                  <img src="public/images/pages/account/icon-messages-active.png">
                  <span>Enviar mensaje</span>
                </a>

                <a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(postulate.name, postulate.usuarios_id)">
                  <i class="far fa-eye icon"></i>
                  <span>Ver Perfil</span>
                </a>
              </div>



              <!-- <div class="col col-buttons">
                <button class="trans-250 btn-squ-1 form-control" @click="savePostulate(postulate.usuarios_id,postulate.vacant_id)" v-if="postulate.favorite == 0">Guardar candidato</button>
                <button class="trans-250 btn-squ-1 form-control" @click="savePostulate(postulate.usuarios_id,postulate.vacant_id)" v-else style="background-color: #1327ca;border-color:#1327ca">Guardado</button>

              </div> -->
            </div>
          </div>

         <!--  <div class="col-12 mt-3">
            <div class="row pagination-container">
              <div class="col-12 col-pagination">
                <b-pagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div> -->

        </div>
      </div>
      <!--  -->

    </div>
    <div class="box-candidates" v-else>
      <p style="text-align: center;"><b>No tienes un plan comprado, porfavor ve a la seccion de planes y compralo.</b></p>
    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
      <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  data(){
    return{
      id:null,
      formFilter: null,

      pagination:{
        current_page:1,
        order:0,
        per_page:10,
      },
      modal:{
          icon:null,
          msg:null
      },
      postulates:[],
      postulatesAll:[],
      filter:{
          category_id:null,
          state_id:null,
          town_id:null,
          keywords:null,
      },
      statesOpcs:[],
      townsOpcs:[],
      areasOpcs:[],
    }
  },
  watch:{
      filter:{
        handler(val){
            if (val.state_id != null) {
                this.getTownsOpcs(val.state_id);
            }
            var newdata = [];
            var check = 0;
          
            if (val.category_id != null) {
                check = 1;
                for (var i = 0; i < this.postulatesAll.length; i++) {
                    if(this.postulatesAll[i]['category_id'] == val.category_id){
                        newdata.push(this.postulatesAll[i]);
                    }
                }
            }

            if (val.state_id != null) {
                if (check == 0) {
                    for (var i = 0; i < this.postulatesAll.length; i++) {
                      if(this.postulatesAll[i]['state_id'] == val.state_id){
                          newdata.push(this.postulatesAll[i]);
                      }
                    }
                    check = 1;
                }
                else{
                    var auxdata = newdata;
                    newdata = [];
                    for (var i = 0; i < auxdata.length; i++) {
                      if(auxdata[i]['state_id'] == val.state_id){
                          newdata.push(auxdata[i]);
                      }
                    }
                }
            }
            if (val.town_id != null) {
                if (check == 0) {
                    for (var i = 0; i < this.postulatesAll.length; i++) {
                      if(this.postulatesAll[i]['town_id'] == val.town_id){
                          newdata.push(this.postulatesAll[i]);
                      }
                    }
                    check = 1;
                }
                else{
                    var auxdata = newdata;
                    newdata = [];
                    for (var i = 0; i < auxdata.length; i++) {
                      if(auxdata[i]['town_id'] == val.town_id){
                          newdata.push(auxdata[i]);
                      }
                    }
                }
            }

            if (val.keywords != null && val.keywords != '') {
                
                var keywordsdata = new RegExp(val.keywords,"i");// '/'+val.keywords+'/i';
                //console.log(keywordsdata);
                 if (check == 0) {
                    for (var i = 0; i < this.postulatesAll.length; i++) {
                      var found = 0;
                      if (this.postulatesAll[i]['email'] != null) {
                        var position = this.postulatesAll[i]['email'].search(keywordsdata);
                        if (position >= 0) {
                            found++;
                        }
                      }
                      if (this.postulatesAll[i]['name'] != null) {
                        var position = this.postulatesAll[i]['name'].search(keywordsdata);
                        if (position >= 0) {
                            found++;
                        }
                      }
                      if (this.postulatesAll[i]['state'] != null) {
                        var position = this.postulatesAll[i]['state'].search(keywordsdata);
                        if (position >= 0) {
                            found++;
                        }
                      }
                      if (this.postulatesAll[i]['town'] != null) {
                        var position = this.postulatesAll[i]['town'].search(keywordsdata);
                        if (position >= 0) {
                            found++;
                        }
                      }
                      if (this.postulatesAll[i]['area'] != null) {
                        var position = this.postulatesAll[i]['area'].search(keywordsdata);
                        if (position >= 0) {
                            found++;
                        }
                      }
                      //console.log(found);
                      if (found > 0) {
                            newdata.push(this.postulatesAll[i]);
                      }
                    }
                    check = 1;
                }
                else{
                    var auxdata = newdata;
                    newdata = [];
                    for (var i = 0; i < auxdata.length; i++) {
                        var found = 0;
                        if (auxdata[i]['email'] != null) {
                            var position = auxdata[i]['email'].search(keywordsdata);
                            if (position >= 0) {
                                found++;
                            }
                        }
                        if (auxdata[i]['name'] != null) {
                            var position = auxdata[i]['name'].search(keywordsdata);
                            if (position >= 0) {
                                found++;
                            }
                        }
                        if (auxdata[i]['state'] != null) {
                            var position = auxdata[i]['state'].search(keywordsdata);
                            if (position >= 0) {
                                found++;
                            }
                        }
                        if (auxdata[i]['town'] != null) {
                            var position = auxdata[i]['town'].search(keywordsdata);
                            if (position >= 0) {
                                found++;
                            }
                        }
                        if (auxdata[i]['vacant'] != null) {
                            var position = auxdata[i]['vacant'].search(keywordsdata);
                            if (position >= 0) {
                                found++;
                            }
                        }
                        if (found > 0) {
                              newdata.push(this.auxdata[i]);
                        }
                    }
                }
                
            }

            if (check == 0) {
                newdata = this.postulatesAll;
            }

            this.postulates = newdata;
        },
        deep:true
      }
     
  },
  methods: {
      
      getData(){
        axios.get(tools.url("/api/admin/postulates"))
        .then((response)=>{
              this.postulates = response.data;
              this.postulatesAll = response.data;
          }).catch((error)=>{
               this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });
      },
      savePostulate(usuarios_id,vacant_id){
            var data = {
              'usuarios_id':usuarios_id,
              'vacant_id':vacant_id
            };
           axios.post(tools.url("/api/admin/saveFavoritePostulateFront"),data).then((response)=>{
              this.$root.auth();
              if(this.$route.params.id){
                this.getDataByVacant();
              }
              else{
                  this.getData();
              }

              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Información actualizada correctamente';
              this.$refs.modalAlert.open();


          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al guardar la información';
              this.$refs.modalAlert.open();

          });
      },
      
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.areasOpcs = response.data;
          }).catch((error)=>{
            
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
  },
  mounted(){
      this.getCategories();
      this.getStatesOpcs();
   
      this.getData();
      
  },

}
</script>
